export default __webpack_public_path__ + "static/media/66.b2043a92.jpg";